import { createContext, useContext, ReactNode, useState } from "react";
import { useLocation } from "react-router";
// import {
//   ApiResponse,
//   ApiErrorResponse,
//   IStaffAuthTokenRequest,
// } from "../utils/types";
// import { UseQueryResult } from "@tanstack/react-query";
// import useGetAuthStaffUserV2 from "../hooks/use-get-authuser";

type AuthStaffUserContextType = {
  userPermission: Record<string, { read: boolean; write: boolean }>;
  setuserPermission: React.Dispatch<
    React.SetStateAction<
      Record<
        string,
        {
          read: boolean;
          write: boolean;
        }
      >
    >
  >;
};

export const AuthStaffUserContext = createContext<AuthStaffUserContextType>({
  userPermission: {},
  setuserPermission: () => {},
});

export const AuthStaffUserProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  // const queryResult = useGetAuthStaffUserV2();

  const [userPermission, setuserPermission] = useState<
    Record<string, { read: boolean; write: boolean }>
  >({});

  return (
    <AuthStaffUserContext.Provider
      value={{ userPermission, setuserPermission }}
    >
      {children}
    </AuthStaffUserContext.Provider>
  );
};

export const useAuthStaffUser = () => {
  const context = useContext(AuthStaffUserContext);
  if (context === undefined) {
    throw new Error(
      "useAuthStaffUser must be used within an AuthStaffUserProvider"
    );
  }
  return context;
};

/**
 * Hook that checks if the current user has write permission for the
 * access page that corresponds to the current URL.
 */
export const useGetUserPermission = (
  pageName?: "tv-app" | "staff"
): { read: boolean; write: boolean } => {
  const { userPermission } = useAuthStaffUser();
  const location = useLocation();

  if (!pageName) {
    const path = location.pathname;
    const match = path.match(/^\/[^\/]+\/([^\/]+)/);
    const secondSegment = match ? match[1] : null;
    pageName = secondSegment as "tv-app" | "staff";
  }

  return userPermission[pageName] || { read: false, write: false };
};
